import { styled } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";

export const Root = styled("div")(() => ({
  overflow: "hidden",
  marginTop: 20,
  marginBottom: 90,
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 30,
  [theme.breakpoints.up("mobile")]: {
    display: "inline-block",
    textTransform: "uppercase",
  },
}));

export const BlankView = styled("div")({
  padding: 25,
  marginBottom: 25,
  textAlign: "center",
  borderRadius: 15,
});

export const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: 10,
  [theme.breakpoints.up("mobile")]: {
    marginTop: 25,
  },
  [theme.breakpoints.up("tablet")]: {
    marginTop: 25,
  },
}));

export const People = styled("div")(({ theme }) => ({
  width: "105%",
  paddingBottom: 20,
  marginTop: 20,
  overflow: "scroll",
  whiteSpace: "nowrap",
  [theme.breakpoints.up("mobile")]: {
    width: "100%",
    textAlign: "center",
    overflow: "hidden",
  },
}));
